import { ROUTES, type RouteName } from './config';

type Listener = (r: RouteName) => void;
const listeners = new Set<Listener>();
let current: RouteName = 'overview';

export function getRoute(): RouteName { return current; }

export function setRoute(next: RouteName) {
  if (!(ROUTES as readonly string[]).includes(next)) return;
  if (next === current) return;
  current = next;
  if (location.hash !== '#/' + next) location.hash = '#/' + next;
  listeners.forEach((l) => l(current));
}

export function onRouteChange(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function bootRouter() {
  const fromHash = (): RouteName => {
    const m = location.hash.match(/^#\/([a-z-]+)/);
    const candidate = m && m[1] as RouteName | undefined;
    return candidate && (ROUTES as readonly string[]).includes(candidate) ? candidate : 'overview';
  };
  current = fromHash();
  window.addEventListener('hashchange', () => {
    current = fromHash();
    listeners.forEach((l) => l(current));
  });
}
